import Page from "@/components/shared/page";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import dynamic from "next/dynamic";
import { connect } from "react-redux";
import FetchingIcon from "../../../public/img/icons/fetching-animated-icon.json";
const Lottie = dynamic(() => import("lottie-react"), { ssr: false });

export const Loading = ({ theme }) => {
	return (
		<Page title="Fetching data...">
			<Grid
				container
				sx={{ backgroundColor: "background.default", height: "100vh", mt: -4 }}
				justifyContent="center"
				alignItems="center"
			>
				<Grid item xs={10} sm={8} md={6} lg={4} xl={3}>
					<Card variant="outlined">
						<CardContent sx={{ textAlign: "center" }}>
							<Box>
								<Box
									component="img"
									src={
										theme === "(prefers-color-scheme: dark)"
											? "/img/tuxis-logo-light.png"
											: "/img/tuxis-logo-dark.png"
									}
									alt="Logo Attuor Notify"
									sx={{ cursor: "pointer", mx: "auto", py: 2, width: { md: "50%", xs: "50%" } }}
								/>
							</Box>

							<Lottie style={{ height: "110px" }} animationData={FetchingIcon} loop autoplay />
							<Typography variant="h6" mt={2} color="primary.main">
								Fetching data...
							</Typography>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</Page>
	);
};

const mapStateToProps = (state) => ({
	theme: state.shared_state.theme,
});

export default connect(mapStateToProps)(Loading);
